import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PlacementConfirmationPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading"); // loading, ready, done, error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/placement-direct/confirm/${token}`);
        setInfo(r.data);
        setState(r.data.deja_confirme ? "done" : "ready");
        if (r.data.deja_confirme) setMsg("Vous avez deja confirme votre presence.");
      } catch (e) { setState("error"); setMsg("Lien invalide ou expire."); }
    })();
  }, [token]);

  const confirmer = async () => {
    try {
      const r = await axios.post(`${API}/api/placement-direct/confirm/${token}`);
      setMsg(r.data.message || "Presence confirmee !");
      setState("done");
    } catch (e) { setMsg("Erreur, reessayez."); }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f4f6", fontFamily: "Arial, sans-serif", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 28, maxWidth: 460, width: "100%", boxShadow: "0 4px 20px rgba(0,0,0,.08)" }}>
        <h1 style={{ color: "#8B1538", marginTop: 0 }}>Confirmation de presence</h1>
        {state === "loading" && <p>Chargement...</p>}
        {state === "error" && <p style={{ color: "#DC2626" }}>{msg}</p>}
        {info && state !== "error" && (
          <>
            <p style={{ fontSize: 15 }}><strong>{info.food_truck_nom}</strong></p>
            <div style={{ background: "#f7f7f7", borderRadius: 8, padding: 14, fontSize: 14, lineHeight: 1.7 }}>
              <div><strong>Evenement :</strong> {info.titre}</div>
              <div><strong>Date :</strong> {info.date}</div>
              <div><strong>Lieu :</strong> {info.lieu || "-"}</div>
              <div><strong>Participation :</strong> {info.montant} EUR</div>
            </div>
            {state === "ready" && (
              <button onClick={confirmer} style={{ marginTop: 20, width: "100%", background: "#22C55E", color: "#fff", border: 0, padding: "14px", borderRadius: 8, fontSize: 16, fontWeight: "bold", cursor: "pointer" }}>
                Je confirme ma presence
              </button>
            )}
            {state === "done" && <p style={{ marginTop: 20, color: "#16a34a", fontWeight: "bold" }}>{msg}</p>}
          </>
        )}
      </div>
    </div>
  );
}
